// UI chrome for the Notable McDonalds subpage (facts stay in English in the data file).
export const notableUI = {
  en: {
    nav: "Notable",
    link: "Notable McDonalds",
    featured: "Featured Figures",
    overline: "The Namebearers",
    title: "Notable McDonalds.",
    subtitle: "A gathering of McDonalds who left their mark on the world — across every spelling, every land and every age.",
    search: "Search by name or field…",
    count: "namebearers",
    back: "Back to home",
    empty: "No namebearers match your search.",
    filter: "Filter by profession",
    all: "All",
    categories: { sport: "Sport", music: "Music", screen: "Stage & Screen", writing: "Writing", science: "Science", military: "Military", clergy: "Faith", politics: "Politics", business: "Business", arts: "Arts", other: "Other" },
    disclaimer: "Biographical facts are listed for reference and educational purposes. Names and factual details are not subject to copyright.",
  },
  fr: {
    nav: "Célèbres",
    link: "McDonald célèbres",
    featured: "Figures marquantes",
    overline: "Les Porteurs du Nom",
    title: "McDonald célèbres.",
    subtitle: "Un rassemblement de McDonald qui ont marqué le monde — toutes graphies, toutes terres et toutes époques confondues.",
    search: "Rechercher par nom ou domaine…",
    count: "porteurs du nom",
    back: "Retour à l'accueil",
    empty: "Aucun porteur du nom ne correspond à votre recherche.",
    filter: "Filtrer par profession",
    all: "Tous",
    categories: { sport: "Sport", music: "Musique", screen: "Scène & Écran", writing: "Écriture", science: "Science", military: "Militaire", clergy: "Foi", politics: "Politique", business: "Affaires", arts: "Arts", other: "Autre" },
    disclaimer: "Les faits biographiques sont indiqués à titre de référence et d'information. Les noms et données factuelles ne sont pas soumis au droit d'auteur.",
  },
  es: {
    nav: "Notables",
    link: "McDonald notables",
    featured: "Figuras destacadas",
    overline: "Los Portadores del Nombre",
    title: "McDonald notables.",
    subtitle: "Una reunión de McDonald que dejaron su huella en el mundo — en cada grafía, cada tierra y cada época.",
    search: "Buscar por nombre o campo…",
    count: "portadores del nombre",
    back: "Volver al inicio",
    empty: "Ningún portador del nombre coincide con tu búsqueda.",
    filter: "Filtrar por profesión",
    all: "Todos",
    categories: { sport: "Deporte", music: "Música", screen: "Escena y Pantalla", writing: "Escritura", science: "Ciencia", military: "Militar", clergy: "Fe", politics: "Política", business: "Negocios", arts: "Artes", other: "Otros" },
    disclaimer: "Los datos biográficos se enumeran con fines de referencia y educativos. Los nombres y datos fácticos no están sujetos a derechos de autor.",
  },
  de: {
    nav: "Bedeutende",
    link: "Bedeutende McDonalds",
    featured: "Herausragende Persönlichkeiten",
    overline: "Die Namensträger",
    title: "Bedeutende McDonalds.",
    subtitle: "Eine Versammlung von McDonalds, die ihre Spuren in der Welt hinterließen — in jeder Schreibweise, jedem Land und jeder Zeit.",
    search: "Nach Name oder Fach suchen…",
    count: "Namensträger",
    back: "Zurück zur Startseite",
    empty: "Keine Namensträger entsprechen deiner Suche.",
    filter: "Nach Beruf filtern",
    all: "Alle",
    categories: { sport: "Sport", music: "Musik", screen: "Bühne & Film", writing: "Literatur", science: "Wissenschaft", military: "Militär", clergy: "Glaube", politics: "Politik", business: "Wirtschaft", arts: "Kunst", other: "Andere" },
    disclaimer: "Biografische Fakten dienen als Referenz und zu Bildungszwecken. Namen und Sachinformationen unterliegen keinem Urheberrecht.",
  },
  it: {
    nav: "Celebri",
    link: "McDonald celebri",
    featured: "Figure di spicco",
    overline: "I Portatori del Nome",
    title: "McDonald celebri.",
    subtitle: "Un raduno di McDonald che hanno lasciato il segno nel mondo — in ogni grafia, ogni terra e ogni epoca.",
    search: "Cerca per nome o ambito…",
    count: "portatori del nome",
    back: "Torna alla home",
    empty: "Nessun portatore del nome corrisponde alla ricerca.",
    filter: "Filtra per professione",
    all: "Tutti",
    categories: { sport: "Sport", music: "Musica", screen: "Scena e Schermo", writing: "Scrittura", science: "Scienza", military: "Militare", clergy: "Fede", politics: "Politica", business: "Affari", arts: "Arte", other: "Altro" },
    disclaimer: "I fatti biografici sono elencati a scopo di riferimento e didattico. I nomi e i dati fattuali non sono soggetti a copyright.",
  },
  gd: {
    nav: "Ainmeil",
    link: "Dòmhnallaich Ainmeil",
    featured: "Prìomh Dhaoine",
    overline: "Luchd-giùlain an Ainm",
    title: "Dòmhnallaich Ainmeil.",
    subtitle: "Cruinneachadh de Dhòmhnallaich a dh'fhàg an comharra air an t-saoghal — anns gach litreachadh, gach dùthaich agus gach linn.",
    search: "Lorg a rèir ainm no raoin…",
    count: "luchd-giùlain an ainm",
    back: "Air ais dhachaigh",
    empty: "Chan eil neach-giùlain sam bith a' freagairt ri do lorg.",
    filter: "Sìolaidh a rèir dreuchd",
    all: "Na h-uile",
    categories: { sport: "Spòrs", music: "Ceòl", screen: "Àrd-ùrlar & Sgrìn", writing: "Sgrìobhadh", science: "Saidheans", military: "Airm", clergy: "Creideamh", politics: "Poilitigs", business: "Gnothachas", arts: "Ealain", other: "Eile" },
    disclaimer: "Tha fìrinnean beatha air an liostadh airson iomraidh is foghlaim. Chan eil ainmean is fìrinnean fo dhlighe-sgrìobhaidh.",
  },
};
